import React  from 'react';
import ReactDOM from 'react-dom/client';

import './i18n'; // Import i18n configuration
import 'react-tooltip/dist/react-tooltip.css'
import "bootstrap/dist/js/bootstrap.bundle.min";
import './custom.scss'; // includes bootstrap.scss

import App from './App';

import {UrlStatusCheckMethods} from "./constants/checkMethods.jsx";
import {IariSources} from "./constants/iariSources.jsx";
import {ParseMethods} from "./constants/parseMethods.jsx";

import './index.css';

const getEnvironment = () => {
    // return 'env-production'
    // return 'env-staging'

    const REGEX_PRODUCTION_ENV = new RegExp(/^(?:(?:[\w-]+\.)+)?(?:[\w-]+\.)?archive\.org$/);  // if "(\.?)archive.org" at end of string
    const host = window.location.host
    if (REGEX_PRODUCTION_ENV.test(host)) return 'env-production'
    if (host === "internetarchive.github.io") return 'env-staging'
    if (host === "localhost:3000") return 'env-local'
    return "env-other"
}

const getIariSource = (qParams, targetEnvironment) => {
    // TODO: will change default to "iari" eventually, when that proxy is stable

    // hard-set to iari_prod for production
    if (targetEnvironment === 'env-production') return IariSources.iari_prod.key

    const defaultIariSourceKey = IariSources.iari_stage.key

    // fall back to default if not specified as url parameter
    const sourceKey = queryParameters.has("iari-source")
        ? queryParameters.get("iari-source")
        : (targetEnvironment === 'env-local')
            ? IariSources.iari_local.key  // default when local
            : defaultIariSourceKey

    // if specified source not in our defined choices, set to default, and log error
    // TODO we should change this so we get a UI run time error
    if (!IariSources[sourceKey]) {
        console.error(`IARI Source ${sourceKey} not supported.`)
        return defaultIariSourceKey
    }

    return sourceKey
}

const getCheckMethod = (qParams, targetEnvironment) => {
    const tempDefaultKey = UrlStatusCheckMethods.LIVEWEBCHECK.key  // hard-set to LIVEWEBCHECK for production

    if (targetEnvironment === 'env-production') return tempDefaultKey
    // else
    const methodKey = queryParameters.has("method") ? queryParameters.get("method") : tempDefaultKey

    // if specified method not in our defined choices, notify as error and default to tempDefaultKey
    if (!UrlStatusCheckMethods[methodKey]) {
        console.error(`Method ${methodKey} not supported.`)
        return tempDefaultKey
    }
    return methodKey
}

/*
article version determines how the article data is interpreted.
 */
const getParseMethod = (qParams, targetEnvironment) => {
    // const defaultParseMethodKey = ParseMethods.WIKIPARSE_V1.key
    const defaultParseMethodKey = ParseMethods.WIKIPARSE_XREF.key

    // ONLY allow default version for production
    if (targetEnvironment === 'env-production')
        return defaultParseMethodKey

    // else respect query param setting
    const parseMethodKey = queryParameters.has("parse_method")
        ? queryParameters.get("parse_method")
        : defaultParseMethodKey

    // return key if OK
    if (ParseMethods[parseMethodKey]) return parseMethodKey

    // see if specified version key is in alternate keys of defined versions
    let altVersionKey
    Object.keys(ParseMethods).some(versionKey => {
        const altKeys = ParseMethods[versionKey].alternate_keys
        if (altKeys && altKeys.includes(parseMethodKey)) {
            altVersionKey = versionKey
            return true  // slip oyt of "some" loop
        } else {
            return false
        }
    })

    if (altVersionKey) return altVersionKey

    // slipping thru here means specified key is not a valid key or a
    // valid alternate key for article version; return default
    console.error(`Parse Method ${parseMethodKey} not supported.`)
    return defaultParseMethodKey

}

// ========================================

const getBooleanParameter = (paramName) => {
    const paramValue = queryParameters.has(paramName) ? queryParameters.get(paramName).toLowerCase() : null
    if (paramValue === null || paramValue === 'false') return false
    if (paramValue === 'true' || paramValue === "1" ) return true
    return null
}

// const root = ReactDOM.createRoot(document.getElementById("root"));
const queryParameters = new URLSearchParams(window.location.search)
const myEnv = getEnvironment();
const myDebug = queryParameters.has("debug") ? queryParameters.get("debug").toLowerCase() === 'true' : false;

const myPath = queryParameters.has("url") ? queryParameters.get("url") : '';
const myIariSourceId = getIariSource(queryParameters, myEnv)
const myCheckMethod = getCheckMethod(queryParameters, myEnv)
const myParseMethod = getParseMethod(queryParameters, myEnv)

const myRefresh = getBooleanParameter("refresh")
const myShowShortcuts = getBooleanParameter("show_shortcuts")
const myUseLocalCache = getBooleanParameter("use_local_cache")
// const myShowShortcuts = queryParameters.has("show_shortcuts") ? queryParameters.get("show_shortcuts").toLowerCase() === 'true' : '';
// const myUseLocalCache = queryParameters.has("use_local_cache") ? queryParameters.get("use_local_cache") : '';

ReactDOM.createRoot(document.getElementById("root")).render(
    // <React.StrictMode>
        <App myEnv={myEnv}
             myPath={myPath}
             myRefresh={myRefresh}
             myShowShortcuts={myShowShortcuts}
             myUseLocalCache={myUseLocalCache}
             myCheckMethod={myCheckMethod}
             myParseMethod={myParseMethod}
             myIariSourceId={myIariSourceId}
             myDebug={myDebug} />
    // </React.StrictMode>
);
